import { RtColumn } from "./RtColumn";
import { AbstractRow } from "./RtTypes";

export const insertColumnAfter = <TRow extends AbstractRow>(
  columns: RtColumn<TRow>[],
  targetKey: string,
  columnToInsert: RtColumn<TRow>,
): RtColumn<TRow>[] => {
  const targetIndex = columns.findIndex((column) => column.key === targetKey);
  if (targetIndex < 0) {
    return [...columns, columnToInsert];
  }
  const nextColumns = [...columns];
  nextColumns.splice(targetIndex + 1, 0, columnToInsert);
  return nextColumns;
};
